<template>
  <div class="view" v-if="canEdit || canDelete" v-cloak>
    <card :title="title" id="holiday-list">
      <agro-filter-container :new-object="newObject" :title='$t("common.create_new")'>
        <s-c-holiday-filters ref="filters" @onFiltersApplied="onFiltersApplied"/>
      </agro-filter-container>
    </card>
    <div class="content-body pt-4">
      <div class="row">
        <div class="col-lg-12">
          <agro-grid
            :headers="headers"
            :rows="items"
            :paginate="true"
            :permission="config"
            :action="onPageSelected"
            :loading="loading"
            @onSortBy="onSortBy"
          >
          </agro-grid>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <forbidden></forbidden>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as type from '../../../store/mutation-types'
import SCHolidayFilters from "@/pages/salary-calculator/sc-holiday/partials/SCHolidayFilters";
import AgroGrid from "@/components/AgroGrid/index";
import {canDelete, canEdit, permissions, permissionTypes} from "@/helpers/Permissions";
import Forbidden from "~/pages/errors/Forbidden.vue";
import AgroFilterContainer from "@/components/AgroFilter/partials/AgroFilterContainer.vue";

export default {
  name: 'SCHolidayList',
  middleware: ['auth', 'check-company-admin'],
  data() {
    return {
      currentPage: 1,
      filters: this.scHolidayFilters ? this.scHolidayFilters : {},
      items: this.scHolidays ? this.scHolidays : [],
      pager: this.pagination ? this.pagination : {},
      loading: false,
    }
  },
  components: {
    AgroFilterContainer,
    Forbidden,
    AgroGrid,
    SCHolidayFilters,
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      scHolidayFilters: 'scHoliday/scHolidayFilters',
      scHolidays: 'scHoliday/scHolidays',
      pagination: 'common/pagination',
      users: 'user/users',
    }),
    title() {
      return this.$t('common.holiday_day');
    },
    config() {
      return {
        permission: permissions.SC_HOLIDAY,
        permission_type: permissionTypes.module,
        edit: {
          url: '/salary-calculator/sc-holiday/{uuid}',
          callback: this.onItemEdited,
        },
        delete: {
          method: this.deleteObject,
          callback: this.onItemDeleted,
        }
      };
    },
    canEdit() {
      return canEdit(this);
    },
    canDelete() {
      return canDelete(this);
    },
    headers() {
      return  [
        { name: this.$t('common.name'), col: 'name', width: '30%' },
        { name: this.$t('common.date'), col: 'date', width: '20%', sortable: true },
        { name: this.$t('common.created_at'), col: 'created_at', width: '20%' },
        { name: this.$t('common.last_update'), col: 'updated_at', width: '20%' },
      ];
    },
  },
  methods: {
    ...mapActions({
      deleteObject: 'scHoliday/deleteSCHoliday',
    }),
    onPageSelected(page_id) {
      this.filters.page = page_id;
      this.$store.commit("scHoliday/"+type.SET_SC_HOLIDAY_FILTERS, this.filters);
      this.$refs.filters.applyFilters();
    },
    newObject() {
      this.$router.push({
        path: 'sc-holiday/add'
      });
    },
    onItemEdited(item) {
      console.log('onItemEdited', item);
    },
    onItemDeleted(item) {
      console.log('onItemDeleted', item);
    },
    onFiltersApplied(filters) {
      this.loading = true;
    },
    onSortBy(data) {
      this.scHolidayFilters.sortBy = data.sortBy;
      this.scHolidayFilters.sortDirection = data.sortDirection;
      this.onPageSelected(this.currentPage);
    }
  },
  watch: {
    scHolidays: {
      handler: function(newVal) {
        this.items = newVal;
      },
      deep: true,
    },
    pagination: {
      handler: function(newVal) {
        this.pager = newVal;
      },
      deep: true,
    },
  }
}
</script>

<style scoped>

</style>
